import type { QueryClient } from "@tanstack/react-query";
import { writeWorkspaceIdToSession } from "./workspaceStorage.js";

/** Persists the active workspace and refetches `/admin/me` so the shell picks up the new context. */
export const switchActiveWorkspace = (queryClient: QueryClient, workspaceId: string) => {
  writeWorkspaceIdToSession(workspaceId);
  void queryClient.invalidateQueries({ queryKey: ["admin", "me"] });
};
